import React from "react";
import { useDispatch } from "react-redux";
import { dndModalOpened } from "../store/components";
import * as theme from "../theme";
import DragAndDropModal from "./DragAndDropModal";

const ReditMainPane = (props) => {
  const dispatch = useDispatch();
  return (
    <React.Fragment>
      <div
        onDragEnter={() => {
          // setHighlighted(true);
          dispatch(dndModalOpened());
        }}
        onDragLeave={() => {
          // setHighlighted(false);
          //  dispatch(dndModalClosed());
        }}
        onDragOver={(e) => {
          e.preventDefault();
        }}
        onDrop={(e) => {
          e.preventDefault();
        }}
        style={{
          ...theme.fwfh,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            zIndex: 1,
            overflow: "scroll",
            backgroundColor: "rgb(239, 243, 247)",
          }}
        >
          {props.children}
        </div>
      </div>
      <DragAndDropModal></DragAndDropModal>
    </React.Fragment>
  );
};

export default ReditMainPane;
